import { useState } from "react";
import swal from "../../utils/swal";
import "../../views/teachers/addTeacher.css";

/**
 * Top-of-form avatar / photo dropzone used by admin add & edit screens.
 */
export default function FormPhotoDrop({
  preview,
  onFile,
  required = false,
  label = "Photo",
  alt = "Preview",
  hint = "PNG, JPG or WEBP · square works best",
  variant = "avatar",
}) {
  const [over, setOver] = useState(false);

  const takeFile = (file) => {
    if (!file) return;
    if (!file.type?.startsWith("image/")) {
      swal("Oops!", "Please select an image file", "error");
      return;
    }
    onFile(file);
  };

  return (
    <div className={`tf-avatar-block${variant === "rect" ? " is-rect" : ""}`}>
      <p className="tf-label">
        {label} {required ? <span>*</span> : null}
      </p>
      <label
        className={`tf-photo${variant === "avatar" ? " tf-photo-avatar" : ""}${
          over ? " is-over" : ""
        }${preview ? " has-file" : ""}`}
        onDragOver={(event) => {
          event.preventDefault();
          setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(event) => {
          event.preventDefault();
          setOver(false);
          takeFile(event.dataTransfer.files?.[0]);
        }}
      >
        <input
          type="file"
          accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
          onChange={(event) => takeFile(event.target.files?.[0])}
        />
        {preview ? <img src={preview} alt={alt} /> : null}
        {!preview ? (
          <span className="tf-photo-text">
            Drag & drop or click to upload
          </span>
        ) : null}
      </label>
      {hint ? <p className="tf-hint tf-avatar-hint">{hint}</p> : null}
    </div>
  );
}
